export default __webpack_public_path__ + "static/media/six.4e941f30.svg";